import * as React from 'react';
import { debounce } from 'ts-debounce';
import { Link } from 'react-router-dom';
import { History } from 'history';
import { fetchApi } from '../services/api';

type Props = {
    history: History;
}

type State = {
    ShowSearchResults: boolean;
    Results: GlobalSearchResult[];
    SelectedIndex: number;
}

type GlobalSearchResult = {
    Name: string;
    Link: string;
}

export default class GlobalSearch extends React.Component<Props, State> {

    private searchInput: React.RefObject<HTMLInputElement>;

    constructor(props: Props) {
        super(props);

        this.state = {
            ShowSearchResults: false,
            Results: [],
            SelectedIndex: 0,
        }

        this.searchInput = React.createRef();
        this.handleShortcuts = this.handleShortcuts.bind(this);
        this.resetSearch = this.resetSearch.bind(this);
    }

    public componentWillMount() {
        document.addEventListener('keydown', this.handleShortcuts);
    }

    public componentWillUnmount() {
        document.removeEventListener('keydown', this.handleShortcuts);
    }

    public render() {
        return <label className="w-100" style={{ position: 'relative', marginBottom: 0 }}>
            <input
                ref={this.searchInput}
                className="form-control form-control-dark w-100"
                type="text"
                onFocus={() => this.setState({ ShowSearchResults: true })}
                onBlur={() => setTimeout(() => {
                    this.setState({ ShowSearchResults: false })
                }, 150)}
                onChange={(e) => this.searchDebounced(e.target.value.trim())}
                placeholder="Search"
                aria-label="Search" />
            <ul className={`search-results list-group ${this.state.ShowSearchResults ? "" : "d-none"}`}>
                {this.state.Results.map((result, index) => {
                    return <Link
                        key={index}
                        to={result.Link}
                        onClick={this.resetSearch}
                        className={`list-group-item ${this.state.SelectedIndex === index ? "active" : ""}`}
                    >
                        {result.Name}
                    </Link>
                })}
            </ul>
        </label>;
    }

    private handleShortcuts(event: any) {

        // Previous
        if (this.state.ShowSearchResults && event.keyCode === 38 && this.state.SelectedIndex > 0) {
            this.setState((prevState) => ({
                SelectedIndex: prevState.SelectedIndex - 1
            }));
            event.preventDefault();
            return;
        }

        // Next
        if (this.state.ShowSearchResults && event.keyCode === 40 && (this.state.SelectedIndex + 1) < this.state.Results.length) {
            this.setState((prevState) => ({
                SelectedIndex: prevState.SelectedIndex + 1
            }));
            event.preventDefault();
            return;
        }

        // Exit
        if (this.state.ShowSearchResults && event.keyCode === 27) {
            this.resetSearch();
        }

        // Select Item
        if (this.state.ShowSearchResults && event.keyCode === 13 && this.state.Results.length) {
            this.props.history.push(this.state.Results[this.state.SelectedIndex].Link);
            this.resetSearch();
        }

        // Ignore if in other inputs
        if (event.target.tagName === "INPUT"
            || event.target.tagName === "SELECT"
            || event.target.tagName === "TEXTAREA"
            || event.target.contentEditable === "true") {
            return;
        }

        // Active Global Search
        if (event.keyCode === 191) {
            if (this.searchInput.current) {
                this.searchInput.current.focus();
                event.preventDefault();
            }
        }
    }

    private searchDebounced = debounce(this.search, 250);

    private search(searchTerm: string) {
        if (searchTerm.length < 3) {
            return;
        }

        const data = {
            SearchTerm: searchTerm,
            FacilityID: localStorage.getItem("FACILITY_ID")
        }

        fetchApi('/api/Search/GlobalSearch', data, 'POST')
            .then((Results: GlobalSearchResult[]) => {
                this.setState({ Results, SelectedIndex: 0 });
            });
    }

    private resetSearch() {
        this.setState({ ShowSearchResults: false, SelectedIndex: 0, Results: [] });
        if (this.searchInput.current) {
            this.searchInput.current.value = '';
            this.searchInput.current.blur();
        }
    }
}
